import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import { Logout } from '@imprivata/nucleus';

class LogoutStyled extends Component {
  /**
   * @param {string} type style color type to use
   */
  static propTypes = { type: PropTypes.string, };
  static defaultProps = { type: 'black', };
  render() {
    const { type, onLogoutClick, } = this.props;

    return <Logout type={type} onLogoutClick={onLogoutClick} />;
  }
}

const mapStateToProps = state => {
  const { isHelpdeskVerificationWorkflow, } = state.login;
  return { isHelpdeskVerificationWorkflow, };
};

const mapDispatchToProps = dispatch => ({
  dispatchLogout: () => dispatch(actions.logout() ),
  dispatchReset: () => dispatch(actions.reset() ),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { isHelpdeskVerificationWorkflow, } = stateProps;
  return {
    type: ownProps.type,
    onLogoutClick: () => {
      if (isHelpdeskVerificationWorkflow) {
        dispatchProps.dispatchReset();
      }
      else {
        dispatchProps.dispatchLogout();
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(LogoutStyled);
